import React from 'react';

interface ProPerkProps {
  title: string;
  description: string;
  logo: React.JSX.Element;
}

const ProPerk = ({ title, description, logo }: ProPerkProps) => {
  return (
    <div className="flex flex-row sm:flex-col">
      {logo}
      <div className="ml-16 sm:ml-0 sm:mt-24">
        <h3 className="m-0 mb-16 font-suisse-screen text-headline-alt-sm text-primary-black">
          {title}
        </h3>
        <p className="m-0 font-suisse-neue text-body-md text-primary-black sm:text-body-lg">
          {description}
        </p>
      </div>
    </div>
  );
};

export default ProPerk;
